import { render } from "./CensusForm.vue?vue&type=template&id=3c5b220f&scoped=true"
import script from "./CensusForm.vue?vue&type=script&lang=js"
export * from "./CensusForm.vue?vue&type=script&lang=js"

import "./CensusForm.vue?vue&type=style&index=0&id=3c5b220f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5b220f"]])

export default __exports__